import React from 'react';
import { StageProppant, StageSheetBox, StageTicket } from '../../../graphql/client/queries/stageQueries';

interface PrintStageSheetProps {
    jobName: string;
    wellheadStages: string;
    proppantDetails: StageProppant[];
    stageSheets: StageSheetBox[];
    bellyDump: boolean;
    innerRef: React.RefObject<HTMLDivElement | null>;
}

const weight = (value: number | null) => (value ?? 0).toLocaleString('en-US');

const StageSheetPrintAllLayout = ({ jobName, wellheadStages, proppantDetails, stageSheets, bellyDump, innerRef }: PrintStageSheetProps) => (
    <div ref={innerRef} className="StageSheet-PrintDocument">
        <div className="StageSheet-Header-To-Print">{jobName} - {wellheadStages}</div>
        <div className="StageSheet-Grid-Container-To-Print">
            <table className="StageSheet-Grid-To-Print">
                <thead><tr><th>Proppant</th><th>Total Weight Needed</th><th>Sand Pumped</th><th>Cumulative Box Weight</th></tr></thead>
                <tbody>
                    {proppantDetails.map((proppant, index) => <tr key={proppant.stageSheetProppantId ?? index}>
                        <td>{proppant.proppantName}</td>
                        <td className={(proppant.totalWeightNeeded ?? 0) < 0 ? 'Td-Red-Background' : ''}>{weight(proppant.totalWeightNeeded)}</td>
                        <td>{weight(proppant.sandPumped)}</td><td>{weight(proppant.totalBoxWeight)}</td>
                    </tr>)}
                </tbody>
            </table>
        </div>
        <div className="StageSheet-Grid-Container-To-Print">
            <table className="StageSheet-Grid-To-Print">
                <thead><tr>
                    <th>Station #</th><th>Box</th><th>Weight</th><th>Accumulated Weight</th><th>Type</th>
                    <th>Pad Location</th><th>Wt. Remaining</th><th>OOS</th><th>PO #</th>
                    {bellyDump ? <><th>Load #</th><th>SandTicket #</th><th>ST Weight</th><th>ST Wt. Remaining</th></>
                        : <><th>Ticket #</th><th>Load#</th></>}
                </tr></thead>
                <tbody>
                    {stageSheets.flatMap((box, boxIndex) => {
                        const tickets = bellyDump ? (box.stageSheetBellyDump ?? [])
                            .filter((ticket): ticket is StageTicket => ticket != null) : [];
                        const rows: (StageTicket | null)[] = tickets.length ? tickets : [null];
                        return rows.map((ticket, ticketIndex) => <tr key={`${box.stageSheetBoxId ?? boxIndex}-${ticket?.id ?? ticketIndex}`}
                            style={{ backgroundColor: boxIndex % 2 === 0 ? '#f2f2f2' : '#fff' }}>
                            {ticketIndex === 0 && <>
                                <td rowSpan={rows.length}>{box.station === '0' ? '' : box.station}</td>
                                <td rowSpan={rows.length}><div className="StageSheet-GreenDot-Container">
                                    {box.boxDesc}{box.isPartial === 'Yes' && <span className="StageSheet-GreenDot" />}
                                </div></td>
                                <td rowSpan={rows.length}>{weight(box.boxWeight)}</td>
                                <td rowSpan={rows.length}>{weight(box.accumulatedWeight)}</td>
                                <td rowSpan={rows.length}>{box.proppant}</td><td rowSpan={rows.length}>{box.location}</td>
                                <td rowSpan={rows.length}>{weight(box.boxWeightRemaining)}</td>
                                <td rowSpan={rows.length}>{box.isOOS ? 'Yes' : 'No'}</td><td rowSpan={rows.length}>{box.sandPo}</td>
                            </>}
                            {bellyDump ? <>
                                <td>{ticket ? ticket.loadId : box.loadId}</td><td>{ticket ? ticket.sandTicket : box.sandTicket}</td>
                                <td>{weight(ticket ? ticket.sandTicketWeight : box.loadWeight)}</td>
                                <td>{ticket ? weight(ticket.sandTicketWeightRemaining) : ''}</td>
                            </> : <><td>{box.sandTicket}</td><td>{box.loadId}</td></>}
                        </tr>);
                    })}
                </tbody>
            </table>
        </div>
    </div>
);

export default StageSheetPrintAllLayout;